import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Loader, Save } from "lucide-react";
import { useSettingsStore } from "@/features/settings/stores";

const SettingsPageHeader = () => {
  const { t } = useTranslation();
  const requestSave = useSettingsStore((s) => s.requestSave);
  const isSaving = useSettingsStore((s) => s.isSaving);

  return (
    <div className="flex-1 flex items-center justify-between w-full">
      <h1 className="lg:text-lg">{t("titles.dashboard.settings")}</h1>
      <Button size="sm" onClick={requestSave} disabled={isSaving}>
        {isSaving ? <Loader className="animate-spin" /> : <Save />}
        {t("keys.save")}
      </Button>
    </div>
  );
};

export default SettingsPageHeader;
